import { markupTemplateLang } from "./shared"

markupTemplateLang("smarty", {
	block: ["{*", "*}"],
})
